export function getToken() {
  return window.token
}


